import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import api from "@/lib/api";
import { Clock, FileText, Loader2, ArrowLeft } from "lucide-react";

const fmt = (d) => (d ? new Date(d).toLocaleDateString([], { year: "numeric", month: "long", day: "numeric" }) : "");

export default function Legal() {
  const { pathname } = useLocation();
  const isPublic = pathname === "/legal";
  const [docs, setDocs] = useState(null);

  useEffect(() => { api.get("/legal").then((r) => setDocs(r.data)).catch(() => setDocs({})); }, []);

  const body = (
    <div className="max-w-3xl mx-auto space-y-6" data-testid="legal-page">
      {!isPublic && (
        <div className="flex items-center gap-2"><FileText className="w-5 h-5 text-emerald-400" /><h1 className="font-display text-2xl font-bold">Legal</h1></div>
      )}
      {!docs ? (
        <div className="grid place-items-center py-20"><Loader2 className="animate-spin text-emerald-500" /></div>
      ) : (
        ["terms", "privacy"].map((k) => (docs[k] ? (
          <section key={k} className="card-emerald p-6" data-testid={`legal-${k}`}>
            <div className="flex items-center gap-2 mb-1"><FileText className="w-5 h-5 text-emerald-400" /><h2 className="font-display text-xl font-bold">{docs[k].title}</h2></div>
            <p className="text-xs text-muted-foreground mb-4">Version {docs[k].version} · Last updated {fmt(docs[k].updated_at)}</p>
            <div className="text-sm text-muted-foreground whitespace-pre-line leading-relaxed">{docs[k].content}</div>
          </section>
        ) : null))
      )}
    </div>
  );

  if (!isPublic) return body;
  return (
    <div className="min-h-screen bg-[#0A0D0C] grid-bg">
      <header className="h-16 flex items-center justify-between px-6 border-b border-emerald-500/15">
        <Link to="/" className="flex items-center gap-2"><div className="w-8 h-8 rounded-lg bg-emerald-500 flex items-center justify-center"><Clock className="w-5 h-5 text-[#062217]" /></div><span className="font-display text-xl font-extrabold">QwikLogs Africa</span></Link>
        <Link to="/" className="text-sm text-muted-foreground hover:text-foreground flex items-center gap-1" data-testid="legal-home-link"><ArrowLeft className="w-4 h-4" /> Home</Link>
      </header>
      <div className="p-6 py-10">{body}</div>
    </div>
  );
}
